import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('api', 'configuracao/apuracao-acordo');

const configuracaoApuracaoAcordo = {
  atualizarTipoAcordo: { method: 'PUT', url: `${basePath}/{nomeAcordo}?valorSelecao={valorSelecao}` },
  atualizarConfiguracoesApuracaoAcordo: { method: 'PUT', url: `${basePath}` },
  atualizarSubConfiguracoesApuracaoAcordo: { method: 'PUT', url: `${basePath}/sub-configuracao` },
  pesquisar: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}` },
  pesquisarConfiguracoesApuracaoAcordo: { method: 'GET', url: `${basePath}/{nomeAcordo}` },
};

export default resource => resource(`${basePath}`, {}, configuracaoApuracaoAcordo);



// WEBPACK FOOTER //
// ./src/common/resources/configuracao/configuracao-apuracao-acordo.js